var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "checkbox" }, [
    _c("label", [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.controlValue.data,
            expression: "controlValue.data",
          },
        ],
        attrs: { type: "checkbox", disabled: !_vm.enabled },
        domProps: {
          checked: Array.isArray(_vm.controlValue.data)
            ? _vm._i(_vm.controlValue.data, null) > -1
            : _vm.controlValue.data,
        },
        on: {
          change: [
            function ($event) {
              var $$a = _vm.controlValue.data,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 &&
                    _vm.$set(_vm.controlValue, "data", $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.controlValue,
                      "data",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.controlValue, "data", $$c)
              }
            },
            _vm.onChange,
          ],
        },
      }),
      _vm._v("\n        " + _vm._s(_vm.label) + "\n    "),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }